<template>
  <div class="sentence-swapper">
    <div class="slider-frame">
      <div class="slides" :style="slideStyle">
        <div 
          v-for="(sentence, index) in sentences" 
          :key="index" 
          class="slide"
        >
          {{ sentence }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sentence-swapper",
  props: {
    sentences: {
      type: Array,
      required: true,
      validator: (value) => value.every(item => typeof item === "string")
    },
    interval: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      currentIndex: 0,
      intervalId: null
    };
  },
  computed: {
    slideStyle() {
      const lineHeight = 50; // Match the CSS line-height
      const translateY = this.currentIndex * -1 * lineHeight;
      return {
        transform: `translateY(${translateY}px)`
      };
    }
  },
  methods: {
    rotate() {
      this.currentIndex = (this.currentIndex + 1) % this.sentences.length;
    }
  },
  mounted() {
    if (this.sentences.length > 1) {
      this.intervalId = setInterval(this.rotate, this.interval);
    }
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
};
</script>

<style scoped>
.sentence-swapper {
  perspective: 1000px;
}

.slider-frame {
  height: 50px;
  overflow: hidden;
  text-align: center;
}

.slides {
  transition: transform 0.6s cubic-bezier(0.4, 0.0, 0.2, 1);
  transform: translateY(0px);
}

.slide {
  font-size: 24px;
  line-height: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
